// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--88a96";
export var title = "Slide-module--title--f788f";
export var name = "Slide-module--name--8f2fc";
export var description = "Slide-module--description--5f5f2";
export var moreButton = "Slide-module--moreButton--605f9";
export var hidden = "Slide-module--hidden--7fecc";
export var figure = "Slide-module--figure--c1bca";
export var img = "Slide-module--img--741bd";
export var link = "Slide-module--link--02a53";
export var linkedinIcon = "Slide-module--linkedinIcon--9c94d";
export var position = "Slide-module--position--06e50";